import {
  Box,
  Container,
  Flex,
  Heading,
  IconButton,
  Img,
  Link,
  ListItem,
  Text,
  UnorderedList,
} from '@chakra-ui/react';
import React from 'react';
import { FaLinkedin } from 'react-icons/fa';

const FundInFocusPranaVentures: React.FC = () => (
  <>
    {/* members */}
    <Flex
      as="section"
      flexDirection="column"
      overflow="hidden"
      justify="center"
      height={{ xs: '450px', sm: '300px' }}
      minH={{ xs: '450px', sm: '300px' }}
      maxH="450px"
      pos="relative"
    >
      <Img
        pos="absolute"
        objectFit="cover"
        src="/jpg/blogBanner.jpg"
        alt="members-hero"
        height="100%"
        width="100%"
      />
      <Box
        bg="linear-gradient(93.48deg, #00001F 45.8%, #186658 74.6%)"
        pos="absolute"
        height="100%"
        width="100%"
        opacity="0.7"
      />
      <Container
        maxW="container.xl"
        position="relative"
        zIndex="1"
        flexDir="column"
        px={{ xs: '20px', sm: '28px', md: '45px', lg: '60px', xl: 'inherit' }}
      >
        <Heading
          as="h1"
          mb="20px"
          variant="reportCardTitle"
          fontSize={{ xs: '26px', sm: '28px', md: '32px', lg: '38px' }}
          color="white"
          lineHeight={{ xs: '34px', md: '39px', lg: '42px' }}
        >
          Fund In Focus: The Fortune in the Middle - Why Prana Ventures Is
          Investing in India’s Rising 60%
        </Heading>
        <Text
          fontSize={{ xs: '18px', sm: '18px', md: '20px', lg: '22px' }}
          fontWeight="600"
          color="white"
          lineHeight="21px"
        >
          Badri Pillapakkam, Managing Partner,
          <Link
            href="https://www.pranaventures.it/en/"
            target="_blank"
            rel="noreferrer"
          >
            Prana Ventures
          </Link>
        </Text>
      </Container>
    </Flex>
    <Container
      as="section"
      maxW="container.xl"
      pb="80px"
      pt="40px"
      minH="420px"
      display={{ xs: 'flex', md: 'inherit' }}
      flexDirection="column"
    >
      <Box as="main" w="100%" pb="40px">
        <Text variant="blogAnswer">
          Welcome to our ‘Fund in Focus’ series where we profile our member VC
          funds, underscore their investment philosophy, and highlight some of
          their interesting work. In this exclusive chat with Badri Pillapakkam,
          Managing Partner, Prana Ventures. In this edition of Fund in Focus, we
          spotlight Prana Ventures, a purpose-driven VC firm founded by the team
          behind Omidyar Network India. In this feature, he explains how Prana
          blends financial discipline with deep impact, focusing on sectors like
          climate, MSMEs, and financial inclusion. With a sharp thesis around
          India’s Aspirers and Seekers, Prana is building a portfolio that’s
          rooted in tech-for-equity and capital efficiency—redefining what it
          means to back startups in Bharat.
        </Text>
      </Box>

      <Img
        src="https://static.levocdn.com/WGLBUT82/Screenshot2025-05-29at10923AM-R6e27N5Izys61.png"
        alt="Perl"
        boxSize="300px"
        float={{ xs: 'right', md: 'left' }}
        alignSelf={{ xs: 'center', md: 'flex-start' }}
        mx={{ xs: '0px', md: '0px' }}
        mr={{ xs: '0px', md: '40px', lg: '60px', xl: '70px' }}
        mb="20px"
        objectFit="contain"
      />
      <Box>
        <Flex flexDir={{ xs: 'column', lg: 'row' }} rowGap="16px">
          <Heading
            textAlign={{ xs: 'center', md: 'left' }}
            fontWeight="800"
            color="blue.400"
          >
            Spokesperson: Badri Pillapakkam, Managing Partner,
            <Link
              href="https://www.pranaventures.it/en/"
              target="_blank"
              rel="noreferrer"
            >
              Prana Ventures
            </Link>
          </Heading>
          <Flex
            columnGap={{ xs: '4px', md: '16px' }}
            justifyContent={{ xs: 'center', md: 'flex-start' }}
            transform={{ xs: 'translateX(12px)', md: 'none' }}
          >
            <Box alignSelf="start" mt="5px">
              <Link
                href="https://www.linkedin.com/in/badripillapakkam/?originalSubdomain=sg"
                target="_blank"
              >
                <IconButton
                  aria-label="linkedin"
                  icon={
                    <FaLinkedin size="28px" color="rgba(100, 100, 140, 0.6)" />
                  }
                  variant="unstyled"
                  cursor="pointer"
                />
              </Link>
            </Box>
          </Flex>
        </Flex>
        <Box
          ml={{ xs: 'auto', md: '345px', lg: '370px' }}
          mr={{ xs: 'auto', md: '0px' }}
          width={{ xs: '160px', md: '80px' }}
          h="2px"
          bgColor="primary.500"
          borderRadius="5px"
          mt={{ xs: '16px', md: '10px' }}
          mb="15px"
        />
        <Box>
          <Heading variant="blogQuestion" pb="20px" pt="16px" pl="-20px">
            1. The name 'Prana' signifies life force—how does that align with
            your investment ethos?
          </Heading>
          <Text variant="blogAnswer" pb="20px">
            Just as Prana is the vital energy or life force behind existence, we
            see our financial and human capital as the energy/driving force
            behind impact innovation, with the entrepreneurs being the ones
            creating the impact. Prana is about balancing spiritual, emotional,
            mental and physical health- similarly, we seek to bring harmony to
            our companies' financial, operational, governance and impact goals.
          </Text>
        </Box>

        {/* Question 2 */}
        <Box pt="20px">
          <Heading variant="blogQuestion" pb="20px" pt="30px">
            2. What inspired the founding team to launch Prana Venture,
            especially at a time of flux in the Indian VC ecosystem?
          </Heading>
          <Box>
            <Text variant="blogAnswer" pb="16px">
              We believe this is the best time to be an Indian VC. Prolonged
              'winter' has meant valuations are more realistic and companies are
              more capital efficient. Exits through M&A and IPOs have become
              tangible.
            </Text>
            <Text variant="blogAnswer" pb="16px">
              The founding team of Prana Ventures is keen to continue a journey
              we pioneered at Omidyar Network India (ONI), where we proved that
              financial and impact returns can co-exist without compromise. We
              believe the Indian start-up ecosystem is best positioned to solve
              some of our country's deepest problems and a tech-for-impact VC
              fund like Prana Ventures can help catalyse these solutions, while
              generating significant financial returns for stakeholders.
            </Text>
            <Text variant="blogAnswer" pb="16px">
              The current flux is not very different from what the Indian PE
              industry went through in 2010-11, with relevant learnings that can
              be applied. We are optimistic that India VC will similarly emerge
              stronger, with good corporate governance norms.
            </Text>
          </Box>
        </Box>

        {/* Question 3 */}
        <Box pt="20px">
          <Heading variant="blogQuestion" pb="20px" pt="30px">
            3. With dry powder at record highs and several new funds being
            raised, what sets Prana Venture apart?
          </Heading>
          <Box>
            <Text variant="blogAnswer" pb="16px">
              We are unique from other VC funds because of our focus on a few
              impactful sectors and our deep understanding of the Aspirers and
              Seekers target audience (i.e. &lt;Rs. 15L annual household income)
              developed from customised third party research and numerous field
              visits over 15 years. Relative to other impact investors, we are
              more tech-focused and sectorally diversified. We are a very
              DPI-focused investor, having returned &gt;1x on aggregate capital
              of ~$150M that the founding team has managed, with an additional
              2x in remaining value. We keep fund sizes small to ensure we meet
              the threshold returns on every fund vehicle.
            </Text>
          </Box>
        </Box>

        {/* Question 4 */}
        <Box pt="20px">
          <Heading variant="blogQuestion" pb="20px" pt="30px">
            4. What do you think LPs are looking for in emerging VC firms
            today—and how are you approaching them?
          </Heading>
          <Box>
            <Text variant="blogAnswer" pb="16px">
              India-focused LPs have significant options to choose from today
              and based on our experience, they are looking for:
            </Text>
            <Box mt="16px">
              <UnorderedList>
                <ListItem>
                  <Text as="span" variant="blogAnswer">
                    An investment strategy that is well-defined and
                    differentiated
                  </Text>
                </ListItem>
                <br />
                <ListItem>
                  <Text as="span" variant="blogAnswer">
                    Credible track record of the GPs following the same strategy
                  </Text>
                </ListItem>
                <br />
                <ListItem>
                  <Text as="span" variant="blogAnswer">
                    An established team that has worked together and is ready to
                    deploy/manage capital
                  </Text>
                </ListItem>
                <br />
                <ListItem>
                  <Text as="span" variant="blogAnswer">
                    Right to win 'hot' deals vs. top VCs
                  </Text>
                </ListItem>
                <br />
                <ListItem>
                  <Text as="span" variant="blogAnswer">
                    Anchor LP to provide gravitas to the fund ideology
                  </Text>
                </ListItem>
                <br />
                <ListItem>
                  <Text as="span" variant="blogAnswer">
                    Complementarity to their existing fund portfolios
                  </Text>
                </ListItem>
                <br />
              </UnorderedList>
            </Box>
            <Text variant="blogAnswer" pb="16px" mt="16px">
              Prana Ventures checks the box on all the points above and because
              we have an existing portfolio of high quality companies offering
              co-investment opportunities to new LPs, we are more similar to a
              2nd time fund manager. Our LP reach-outs so far have been all
              inbound/direct, with a focus on international and domestic
              institutional investors and family offices.
            </Text>
          </Box>
        </Box>

        {/* Question 5 */}
        <Box pt="20px">
          <Heading variant="blogQuestion" pb="20px" pt="30px">
            5. What sectors and themes will be core to Prana's investment
            thesis—and why?
          </Heading>
          <Box>
            <Text variant="blogAnswer" pb="16px">
              Each fund vehicle has a set of 3-4 focus sectors that are
              identified based on the potential for:
            </Text>
            <Box mt="16px">
              <UnorderedList>
                <ListItem>
                  <Text as="span" variant="blogAnswer">
                    Transformation through technology
                  </Text>
                </ListItem>
                <br />
                <ListItem>
                  <Text as="span" variant="blogAnswer">
                    Impact - utilitarian, not hedonistic
                  </Text>
                </ListItem>
                <br />
                <ListItem>
                  <Text as="span" variant="blogAnswer">
                    Steady supply of entrepreneurs innovating in the space
                  </Text>
                </ListItem>
                <br />
              </UnorderedList>
            </Box>
            <Text variant="blogAnswer" pb="16px" mt="16px">
              Accordingly, Prana's Fund I will primarily invest in Financial
              Services, Climate, MSME and opportunistically in Education,
              Healthcare and Agriculture. Climate & MSME have become very
              relevant sectors post-Covid and India has a big role to play in
              innovating for these spaces, with potential for global impact. The
              opportunistic sectors are ones that we have a deep understanding
              of, having invested in a successful portfolio over the years, but
              see that VCs are not active in/have 'abandoned'.
            </Text>
          </Box>
        </Box>

        {/* Question 6 */}
        <Box pt="20px">
          <Heading variant="blogQuestion" pb="20px" pt="30px">
            6. As per a media report, you mentioned a focus on the "bottom 60%
            of India's income pyramid." What kind of business models or startups
            fit this vision?
          </Heading>
          <Box>
            <Text variant="blogAnswer" pb="16px">
              Prana's investment strategy targets the Aspirers (top layer of the
              bottom 60%) and the Seekers (60th-90th percentile of income
              pyramid). Business models targeting the Aspirers and Seekers have
              a few noteworthy aspects:
            </Text>
            <Box mt="16px">
              <UnorderedList>
                <ListItem>
                  <Text as="span" variant="blogAnswer">
                    Are designed for high volume, low ARPU and technology has a
                    key role to play here
                  </Text>
                </ListItem>
                <br />
                <ListItem>
                  <Text as="span" variant="blogAnswer">
                    Are built on 'frugal innovation', i.e. low cost-to-serve to
                    maintain positive unit economics
                  </Text>
                </ListItem>
                <br />
                <ListItem>
                  <Text as="span" variant="blogAnswer">
                    Leverage low-cost acquisition channels (e.g. influencers,
                    existing offline points-of-presence)
                  </Text>
                </ListItem>
                <br />
                <ListItem>
                  <Text as="span" variant="blogAnswer">
                    Tap into alternate streams of revenues (e.g. advertising,
                    tipping)
                  </Text>
                </ListItem>
                <br />
              </UnorderedList>
            </Box>
          </Box>
        </Box>

        {/* Question 7 */}
        <Box pt="20px">
          <Heading variant="blogQuestion" pb="20px" pt="30px">
            7. Will you be building a new portfolio from scratch, or will some
            of Omidyar's investees carry forward into Prana's ecosystem?
          </Heading>
          <Box>
            <Text variant="blogAnswer" pb="16px">
              Prana Ventures is currently managing ONI's equity portfolio with
              40+ companies representing a cost base of ~USD 160M and
              simultaneously raising capital for a new fund. New portfolio will
              be developed post initial close.
            </Text>
          </Box>
        </Box>

        {/* Question 8 */}
        <Box pt="20px">
          <Heading variant="blogQuestion" pb="20px" pt="30px">
            8. How do you maintain continuity for founders while also
            establishing a new brand identity?
          </Heading>
          <Box>
            <Text variant="blogAnswer" pb="16px">
              A brand identity is a manifestation of the people, values and
              culture behind it. As most of us have worked together at ONI for
              7-10 years, continuity is relatively easy as our founders have
              already experienced. Having a similar strategy helps with
              continuity and ease of understanding for the outside world. We
              have, however, incorporated learnings and market feedback from our
              15 years of investing in India to refine our investment strategy,
              stage of investing and ways of working as we look to establish a
              new brand identity. We are very early in this journey and will
              evolve our brand identity along the way.
            </Text>
          </Box>
        </Box>

        {/* Question 9 */}
        <Box pt="20px">
          <Heading variant="blogQuestion" pb="20px" pt="30px">
            9. How do you see the role of impact-driven VC evolving in India's
            next decade of growth?
          </Heading>
          <Box>
            <Text variant="blogAnswer" pb="16px">
              With climate change, rise of artificial intelligence (and its
              impact on unemployment) and further skewing of income (top 10%
              generating 57%) and wealth (top 10% owning 65%) distribution in
              the country, particularly in the last 5 years, the role of impact
              VCs has become more relevant than before. India has to be very
              thoughtful about more equitable growth in the next decade and as
              impact VCs, we will look to create access and opportunity for
              lower income population through technology, while also reducing
              the harms caused by rapid growth.
            </Text>
          </Box>
        </Box>

        {/* Question 10 */}
        <Box pt="20px">
          <Heading variant="blogQuestion" pb="20px" pt="30px">
            10. What kind of founder DNA are you most excited to back?
          </Heading>
          <Box>
            <Text variant="blogAnswer" pb="16px">
              At Prana Ventures, we look to partner with mission-driven
              entrepreneurs who are:
            </Text>
            <Box mt="16px">
              <UnorderedList>
                <ListItem>
                  <Text as="span" variant="blogAnswer">
                    Highly passionate about solving deep problems that they have
                    experienced first hand
                  </Text>
                </ListItem>
                <br />
                <ListItem>
                  <Text as="span" variant="blogAnswer">
                    Nimble and open to feedback, while staying true to their
                    principles/beliefs
                  </Text>
                </ListItem>
                <br />
                <ListItem>
                  <Text as="span" variant="blogAnswer">
                    Believers in our 'sustainable growth' mantra, with impetus
                    on capital efficiency
                  </Text>
                </ListItem>
                <br />
                <ListItem>
                  <Text as="span" variant="blogAnswer">
                    Transparent and maintain high corporate governance standards
                  </Text>
                </ListItem>
                <br />
                <ListItem>
                  <Text as="span" variant="blogAnswer">
                    Tenacious through market ups and downs
                  </Text>
                </ListItem>
                <br />
              </UnorderedList>
            </Box>
          </Box>
        </Box>
      </Box>
      <Heading
        variant="blogQuestion"
        lineHeight="30px"
        pt="16px"
        fontStyle="italic"
        p="12px 12px 0px"
      >
        The content in this section is curated by Team IVCA. For any feedback,
        connect with&nbsp;
        <Link
          href="mailto:paromita.sinha@ivca.in"
          target="_blank"
          style={{ color: 'blue', textDecoration: 'underline' }}
        >
          paromita.sinha@ivca.in
        </Link>
      </Heading>
    </Container>
  </>
);

export default FundInFocusPranaVentures;
